import stateCityData from "@/component/GoldSilver/state_city_list.json";

let flatCityList = null;
let flatLookupList = null;
let flatStateList = null;

export function getGoldSilverCities() {
  if (flatCityList) return flatCityList;

  const states = stateCityData?.[0]?.states || [];
  flatCityList = states.flatMap((state) =>
    (state.cities || []).map((city) => ({
      city: city.city,
      city_hn: city.city_hn,
      city_url: city.url,
    }))
  );

  return flatCityList;
}

// Same as getGoldSilverCities but also includes each state itself as an
// entry (e.g. "Tamil Nadu" / "tamil-nadu"), for resolving state-level
// gold/silver rate page slugs that aren't tied to a specific city.
export function getGoldSilverCitiesAndStates() {
  if (flatLookupList) return flatLookupList;

  const states = stateCityData?.[0]?.states || [];
  flatLookupList = states.flatMap((state) => [
    {
      city: state.state,
      city_hn: state.state_hn,
      city_url: state.url,
    },
    ...(state.cities || []).map((city) => ({
      city: city.city,
      city_hn: city.city_hn,
      city_url: city.url,
    })),
  ]);

  return flatLookupList;
}

// Returns each state with a representative city (its first listed city) since
// upstream gold/silver prices are only published per-city, not per-state.
export function getGoldSilverStates() {
  if (flatStateList) return flatStateList;

  const states = stateCityData?.[0]?.states || [];
  flatStateList = states
    .filter((state) => state?.cities?.length)
    .map((state) => ({
      state: state.state,
      state_hn: state.state_hn,
      state_url: state.url,
      representativeCity: state.cities[0].city,
    }));

  return flatStateList;
}

const normalizeName = (str = "") => str?.toLowerCase()?.replace(/-/g, " ")?.trim();

// Returns the flat {city, city_hn, city_url} list of cities belonging to the
// same state as the given city/state name or url-slug (e.g. "lucknow" or
// "tamil-nadu"). Falls back to the full city list if no match is found.
export function getCitiesForLocation(nameOrSlug) {
  const target = normalizeName(nameOrSlug);
  if (!target) return getGoldSilverCities();

  const states = stateCityData?.[0]?.states || [];
  const matchedState = states.find((state) => {
    if (normalizeName(state.state) === target || normalizeName(state.url) === target) return true;
    return (state.cities || []).some(
      (city) => normalizeName(city.city) === target || normalizeName(city.url) === target
    );
  });

  if (!matchedState) return getGoldSilverCities();

  return (matchedState.cities || []).map((city) => ({
    city: city.city,
    city_hn: city.city_hn,
    city_url: city.url,
  }));
}

// Returns the url-slug (e.g. "tamil-nadu") of the state that the given
// city/state name or url-slug belongs to. Falls back to "uttar-pradesh"
// (the site's default/original state) if no match is found.
export function getStateSlugForLocation(nameOrSlug) {
  const target = normalizeName(nameOrSlug);
  const states = stateCityData?.[0]?.states || [];

  const matchedState = states.find((state) => {
    if (normalizeName(state.state) === target || normalizeName(state.url) === target) return true;
    return (state.cities || []).some(
      (city) => normalizeName(city.city) === target || normalizeName(city.url) === target
    );
  });

  return matchedState?.url || "uttar-pradesh";
}
